import React from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";

function GridHeader() {
  const { isModalPage } = useSelector((state) => ({
    isModalPage: state.Layout.isModalPage,
  }));

  if (isModalPage) return <></>;

  return (
    <div>
      <Row>
        <Col>
          <h5 style={{ fontWeight: 600, marginBottom: "8px" }}>
            Conhecimento de Transporte - Anulação
          </h5>
        </Col>
      </Row>

      <hr />
    </div>
  );
}

export default GridHeader;
